import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Markdown, Slider, Text } from "@wojo/ui";
import { useId } from "react";
import { useTourPageContext } from "../../_client/context";
import { TourSectionId } from "../../_client/hooks";
import { AccommodationCard } from "./AccommodationCard";
import styles from "./Accommodations.module.scss";

export const Accommodations: React.FC = () => {
    const { pageConfig, tourContent } = useTourPageContext();
    const headingId = useId();
    const { productPage } = useI18n("productPage");

    const accommodationsDescription = pageConfig.accommodationsDescription;
    const accommodations = tourContent.accommodations;

    if (accommodations.length === 0) {
        return null;
    }

    return (
        <section
            id={TourSectionId.ACCOMMODATIONS}
            tabIndex={-1}
            aria-labelledby={headingId}
            className={styles.container}
        >
            <Text.Heading
                order="3"
                tag="h2"
                id={headingId}
                style={{ paddingBottom: "var(--g-spacing-sm)" }}
            >
                {productPage.accommodations.heading.l()}
            </Text.Heading>
            {!!accommodationsDescription && (
                <Markdown
                    markdown={accommodationsDescription}
                    className={styles.markdown}
                    onLinkClick={(_, a) => {
                        gtmSendEvent({
                            event: "track",
                            ga4_object: "LINK",
                            ga4_action: "CLICKED",
                            clickText: a.innerText,
                        });
                    }}
                />
            )}
            <Slider
                desktopWidth="280px"
                tabletWidth="280px"
                mobileWidth="280px"
                slidesToScroll="auto"
                onSliderButtonClick={(direction) => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_action: "SCROLLED",
                            ga4_object: "PHOTO_GALLERY",
                            galleryType: "accommodationsGallery",
                            mediaType: "PHOTO",
                            direction,
                        },
                    });
                }}
            >
                {accommodations.map((accommodation) => {
                    return (
                        <AccommodationCard
                            key={accommodation.name}
                            accommodation={accommodation}
                        />
                    );
                })}
            </Slider>
        </section>
    );
};
